<div class="files-tab">
  <div class="row">
    <div class="col-md-12">
      <h5>Location Files</h5>

      <!-- Files List -->
      <div *ngIf="loadingFiles" class="text-center" style="padding: 20px">
        <span>Loading files...</span>
      </div>

      <div *ngIf="!loadingFiles && files.length > 0" style="margin-bottom: 20px">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Preview</th>
              <th>Name</th>
              <th>Uploaded</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let file of files">
              <td style="width: 80px">
                <div class="file-preview">
                  <!-- Image Preview -->
                  <img
                    *ngIf="isImageFile(file.originalName || file.name)"
                    [src]="getImageUrl(file.name)"
                    [alt]="file.originalName || file.name"
                    class="file-thumbnail"
                    (click)="openFilePreview(file)"
                    loading="lazy"
                  />
                  <!-- Non-Image File Icon -->
                  <div
                    *ngIf="!isImageFile(file.originalName || file.name)"
                    class="file-icon"
                    (click)="openFilePreview(file)"
                  >
                    <i class="fa" [ngClass]="getFileIcon(file.originalName || file.name)"></i>
                    <div class="file-type">
                      {{ getFileExtension(file.originalName || file.name) }}
                    </div>
                  </div>
                </div>
              </td>
              <td>{{ file.originalName || file.name }}</td>
              <td>{{ formatDate(file.dateCreatedUtc) }}</td>
              <td>
                <button
                  class="btn btn-sm btn-info"
                  (click)="openFilePreview(file)"
                  style="margin-right: 5px"
                  title="Preview"
                >
                  <i class="fa fa-eye"></i> Preview
                </button>
                <button
                  class="btn btn-sm btn-primary"
                  (click)="downloadFile(file)"
                  style="margin-right: 5px"
                  title="Download"
                >
                  <i class="glyphicon glyphicon-download"></i> Download
                </button>
                <button
                  *ngIf="isEditMode"
                  class="btn btn-sm btn-danger"
                  (click)="deleteFile(file.id)"
                  title="Delete"
                >
                  <i class="glyphicon glyphicon-trash"></i> Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        *ngIf="!loadingFiles && files.length === 0"
        style="margin-bottom: 20px; padding: 20px; text-align: center"
      >
        <p>No files uploaded yet.</p>
      </div>

      <!-- File Upload Section -->
      <div *ngIf="isEditMode" style="margin-top: 20px">
        <hr />
        <h5>Upload Files</h5>
        <div class="form-group">
          <input
            type="file"
            #fileInput
            (change)="fileSelected($event)"
            multiple
            style="display: none"
            accept=".jpg,.jpeg,.pdf,.tiff,.tif"
          />
          <button
            type="button"
            class="btn btn-default"
            (click)="fileInput.click()"
            [disabled]="uploadingFiles"
            style="margin-top: 10px"
          >
            <i class="fa fa-upload" aria-hidden="true"></i>
            {{ uploadingFiles ? "Uploading..." : "Select Files" }}
          </button>
          <p style="margin-top: 10px; font-size: 12px; color: #666">
            Supported formats: JPG, JPEG, PDF, TIFF
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- File Preview Modal -->
<p-dialog
  [(visible)]="showPreviewModal"
  [header]="previewFile ? previewFile.originalName || previewFile.name : 'File Preview'"
  [modal]="true"
  [style]="{ width: '90vw', maxWidth: '1400px' }"
  [draggable]="false"
  [resizable]="true"
  [styleClass]="'file-preview-dialog'"
  [contentStyle]="{ height: 'calc(90vh - 150px)', overflow: 'hidden', padding: '0' }"
>
  <div class="file-preview-content" *ngIf="previewFile">
    <!-- Image Preview -->
    <div
      *ngIf="isImageFile(previewFile.originalName || previewFile.name)"
      class="image-preview-container"
    >
      <img
        [src]="getImageUrl(previewFile.name)"
        [alt]="previewFile.originalName || previewFile.name"
        class="preview-image"
      />
    </div>

    <!-- PDF Preview -->
    <div
      *ngIf="isPdfFile(previewFile.originalName || previewFile.name)"
      class="pdf-preview-container"
    >
      <iframe [src]="getPdfUrl(previewFile.name)" class="pdf-viewer" frameborder="0"> </iframe>
    </div>

    <!-- Other File Types -->
    <div
      *ngIf="
        !isImageFile(previewFile.originalName || previewFile.name) &&
        !isPdfFile(previewFile.originalName || previewFile.name)
      "
      class="file-info-container"
    >
      <div class="file-info">
        <i class="fa" [ngClass]="getFileIcon(previewFile.originalName || previewFile.name)"></i>
        <h4>{{ previewFile.originalName || previewFile.name }}</h4>
        <p>Preview not available for this file type</p>
        <button class="btn btn-primary" (click)="downloadFile(previewFile)">
          <i class="fa fa-download"></i> Download File
        </button>
      </div>
    </div>
  </div>

  <p-footer>
    <div class="button-group">
      <span class="file-info-text"
        ><strong>Uploaded:</strong> {{ formatDate(previewFile?.dateCreatedUtc) }}</span
      >
      <button class="btn btn-primary" (click)="downloadFile(previewFile)">
        <i class="fa fa-download"></i> Download
      </button>
      <button class="btn btn-secondary" (click)="closePreviewModal()">Close</button>
    </div>
  </p-footer>
</p-dialog>
